__turbopack_context__.v({
  "icon": "Icon-module__KiUX9G__icon",
});
